import React from 'react';
import {useEffect, useState} from "react";
import axiosClient from "../axios-client.js";
import swal from 'sweetalert';
import LoadingSpinner from '../components/LoadingSpinner';
import {useStateContext} from "../contexts/ContentProvider";
import {Link, Outlet, useNavigate} from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import {isMembership} from "../utils/memberships.js";

const ComprarClases = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [clickEnabled, setClickEnabled] = useState(true);
  const [showFestejoModal, setShowFestejoModal] = useState(false);
  const [showMembershipModal, setShowMembershipModal] = useState(false);
  const [pendingPackage, setPendingPackage] = useState(null);
  const {setUser, getUser, setToken, getToken} = useStateContext();
  const token = getToken();
  const navigate = useNavigate();

  useEffect(() => {
    getPackages();
  }, []);

  const getPackages = () => {
    setLoading(true)
    axiosClient.get(token? '/packages-active': '/packages-guest')
      .then(({ data }) => {
        setLoading(false)
        setPackages(data.data)
      })
      .catch(() => {
        setLoading(false)
      })
  }

  const addCommasToNumber = (numberString) => {
    const parts = numberString.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  const createCheckout = (package_data) => {
    if (!package_data.payment_link || !clickEnabled) return;

    if(!token) {
      swal({
        title: "Sesión / Registro",
        text: "Favor de voler a iniciar sesión o registrate para poder comprar paquetes.",
        closeOnClickOutside: false,
        closeOnEsc: false,
        backdrop: true,
        icon: "warning",
      }).then(() => {
        localStorage.removeItem('ACCESS_TOKEN')
        localStorage.removeItem('USER_DATA')
        navigate('/auth/login')
      });
      return;
    }

    // If festejo, show confirmation modal first
    if (package_data.type === 'festejo') {
      setPendingPackage(package_data);
      setShowFestejoModal(true);
      return;
    }

    // If membership, show terms modal first
    if (isMembership(package_data.type)) {
      setPendingPackage(package_data);
      setShowMembershipModal(true);
      return;
    }

    proceedToCheckout(package_data);
  };

  const proceedToCheckout = (package_data) => {
    setClickEnabled(false);

    axiosClient.post('/checkout', {
      id: package_data.id,
      product_id: package_data.payment_link
    })
    .then(({data}) => {
      window.location.href = data.url;
    })
    .catch(() => {
      swal({
        title: "Error con el sistema de pagos",
        text: "Una disculpa, favor de contactar al personal para comprar directamente en lo que arreglamos el error",
        icon: "error",
      });
    })
    .finally(() => {
      setClickEnabled(true);
    });
  }

  const memberships = packages.filter(p => isMembership(p.type));
  const regularPackages = packages.filter(p => !isMembership(p.type));

  const renderCard = (p) => {
    const isPopular = (p.num_classes === 15) || (p.num_classes === 17);
    const isPremium = (p.num_classes === 20) || (p.num_classes === 23);
    return (
      <div className="col-12 col-md-6 col-lg-4" key={p.id}>
        <div
          className={`pkg-card ${isPopular ? 'pkg-card--popular' : ''} ${isPremium ? 'pkg-card--premium' : ''} ${clickEnabled ? 'pointer' : 'disabled'}`}
          onClick={() => createCheckout(p)}
        >
          {isPopular && <span className="pkg-badge">Most<br />Popular</span>}
          {p.description && <p className="pkg-description">{p.description}</p>}
          <p className="pkg-price">${addCommasToNumber(p.price)}<sup>00</sup></p>
          <span className="pkg-name">
            <span className={isPremium ? 'pkg-name-text' : ''}>{p.name}</span>
          </span>
          <p className="pkg-expiration">Vigencia de {p.expiration_days} días.</p>
        </div>
      </div>
    );
  };

  return (
    <div className='container-fluid packages-page'>
      <div className='container'>

        {/* ── Sección membresías ───────────────────────────────── */}
        {!loading && memberships.length > 0 && (
          <>
            <h1 className='hero-title pt-5'>Membresía — Clases ilimitadas</h1>
            <p className='center mb-4' style={{ color: 'rgba(255,255,255,0.6)' }}>
              Acceso ilimitado a tu disciplina favorita durante 30 días.
            </p>
            <div className='packages-container row justify-content-center mb-5'>
              {memberships.map(renderCard)}
            </div>
          </>
        )}

        {/* ── Sección paquetes regulares ───────────────────────── */}
        <h1 className='hero-title' style={{ paddingTop: loading || memberships.length === 0 ? '3rem' : 0 }}>
          Paquetes de clases
        </h1>
        <p className='center mb-4'>Contamos con <b>TotalPass</b> y <b>Wellhub</b>.</p>

        {loading ? (
          <div className='loading-container center'>
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <div className='packages-container row justify-content-center'>
            {regularPackages.length === 0 ? (
              <p className='text-center'>De momento no tenemos los paquetes listos, favor de intentarlo en otro momento.</p>
            ) : (
              regularPackages.map(renderCard)
            )}
            {!clickEnabled && <LoadingSpinner />}
          </div>
        )}

        {/* ── Modal términos membresía ─────────────────────── */}
        <Modal show={showMembershipModal} onHide={() => setShowMembershipModal(false)} centered>
          <Modal.Header
            closeButton
            style={{
              background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
              border: 'none',
            }}
          >
            <Modal.Title style={{ color: '#fff', fontWeight: 'bold' }}>
              Membresía — Condiciones importantes
            </Modal.Title>
          </Modal.Header>

          <Modal.Body style={{ background: '#1e1e2e', padding: '1.5rem 2rem' }}>
            <p style={{ color: 'rgba(255,255,255,0.6)', marginBottom: '1rem', fontSize: '0.85rem' }}>
              Antes de continuar, asegúrate de haber leído y aceptado los siguientes puntos:
            </p>
            <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 1rem 0' }}>
              {[
                'Clases ilimitadas al mes dentro de la disciplina contratada.',
                'Solo puedes reservar un lugar por clase.',
                'Las clases de la membresía no podrán ser utilizadas por otra persona.',
                'Mínimo de cancelación 10 horas antes de clase.',
                'Sin flexibilidad de cambio de horario.',
                'No hay justificación de falta.',
                '$100 pesos por no asistencia — el pago se realiza directamente en el estudio.',
                'Tienes 24 horas para saldar tu deuda; de lo contrario las clases reservadas con tu membresía serán canceladas y no podrás reservar.',
                'Asegúrate de acercarte al personal de Front Desk para marcar tu asistencia en cada clase. De lo contrario tendrás un "No Asistió".',
              ].map((item, i) => (
                <li
                  key={i}
                  style={{ display: 'flex', alignItems: 'flex-start', gap: '0.6rem', marginBottom: '0.75rem' }}
                >
                  <span style={{ color: '#e53935', fontWeight: 'bold', flexShrink: 0, fontSize: '1rem', marginTop: '1px' }}>○</span>
                  <span style={{ color: 'rgba(255,255,255,0.85)', fontSize: '0.88rem', lineHeight: '1.5' }}>{item}</span>
                </li>
              ))}
            </ul>
          </Modal.Body>

          <Modal.Footer style={{ border: 'none', background: '#1e1e2e', padding: '0.5rem 2rem 1.5rem' }}>
            <Button
              variant="outline-secondary"
              style={{ color: 'rgba(255,255,255,0.6)', borderColor: 'rgba(255,255,255,0.2)', background: 'transparent' }}
              onClick={() => setShowMembershipModal(false)}
            >
              Cancelar
            </Button>
            <Button
              disabled={!clickEnabled}
              style={{
                background: 'linear-gradient(135deg, rgb(59, 87, 246) 0%, rgb(37, 60, 200) 100%)',
                border: 'none',
                fontWeight: 'bold',
                padding: '0.5rem 1.4rem',
                letterSpacing: '0.02em',
              }}
              onClick={() => {
                setShowMembershipModal(false);
                proceedToCheckout(pendingPackage);
              }}
            >
              Acepto y quiero continuar
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showFestejoModal} onHide={() => setShowFestejoModal(false)} centered>
          <Modal.Header
            closeButton
            style={{
              background: 'linear-gradient(135deg, rgb(59, 87, 246) 0%, rgb(37, 60, 200) 100%)',
              border: 'none',
            }}
          >
            <Modal.Title style={{ color: '#fff', fontWeight: 'bold' }}>
              🎂 Birthday Ride — ¿Qué incluye?
            </Modal.Title>
          </Modal.Header>

          <Modal.Body style={{ padding: '1.5rem 2rem' }}>
            <p style={{ color: 'rgba(255,255,255,0.75)', marginBottom: '1rem', fontSize: '0.9rem' }}>
              ¡Celebra tu cumpleaños pedaleando con tus amigos! Tu paquete incluye:
            </p>
            <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 1rem 0' }}>
              {[
                'Reserva exclusiva del estudio para ti y tu grupo',
                'Decoración temática de cumpleaños',
                'Playlist personalizada a tu gusto',
                'Instructor dedicado para la sesión',
                'Sesión fotográfica durante la clase',
                'Cortesía de bienvenida para todos los asistentes',
              ].map((item, i) => (
                <li
                  key={i}
                  style={{ display: 'flex', alignItems: 'flex-start', gap: '0.6rem', marginBottom: '0.7rem' }}
                >
                  <span style={{ color: 'rgb(59, 87, 246)', fontWeight: 'bold', flexShrink: 0, fontSize: '1rem' }}>✓</span>
                  <span style={{ color: '#fff', fontSize: '0.9rem' }}>{item}</span>
                </li>
              ))}
            </ul>
            <div style={{ borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: '0.75rem' }}>
              <p style={{ fontSize: '0.82rem', color: 'rgba(255,255,255,0.4)', margin: 0 }}>
                Una vez completado el pago, el equipo de Psycle se pondrá en contacto contigo para coordinar los detalles de tu evento.
              </p>
            </div>
          </Modal.Body>

          <Modal.Footer style={{ border: 'none', background: '#1e1e2e', padding: '0.5rem 2rem 1.5rem' }}>
            <Button
              variant="outline-secondary"
              style={{ color: 'rgba(255,255,255,0.6)', borderColor: 'rgba(255,255,255,0.2)', background: 'transparent' }}
              onClick={() => setShowFestejoModal(false)}
            >
              Cancelar
            </Button>
            <Button
              disabled={!clickEnabled}
              style={{
                background: 'linear-gradient(135deg, rgb(59, 87, 246) 0%, rgb(37, 60, 200) 100%)',
                border: 'none',
                fontWeight: 'bold',
                padding: '0.5rem 1.4rem',
                letterSpacing: '0.02em',
              }}
              onClick={() => {
                setShowFestejoModal(false);
                proceedToCheckout(pendingPackage);
              }}
            >
              ¡Sí, quiero celebrar! 🎉
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default ComprarClases;